import { __assign, __read, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from "../../Style/MoaStyled";
import { Typography } from '../../';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import { useEffect, useState } from 'react';
var StyledComponent = styled(function (props) {
    var id = props.id, text = props.text, rest = __rest(props, ["id", "text"]);
    var _a = __read(useState(''), 2), checkedValues = _a[0], setCheckedValues = _a[1];
    useEffect(function () {
        if (rest && rest.children && rest.children.length > 0) {
            var values = rest.children.map(function (child) { return child.props.checked; });
            setCheckedValues(values.join(','));
        }
    }, [rest]);
    return (_jsx("div", { id: id, "data-current-value": checkedValues, children: _jsxs(FormControl, { children: [text && (_jsx("div", { style: { padding: "0.25rem" }, children: _jsx(Typography, { children: text }) })), _jsx(FormGroup, __assign({}, rest, { style: { paddingLeft: text ? "0.5rem" : "0rem" } }))] }) }));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
